import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import EventEmitter from '../../../../utils/events'
import '../actionmenu.scss'

// Actions
import { triggerPopup } from '../../../../actions/backdrop'
import { deleteOrder, deleteOrderSimple, moveOrder, GetNewDeliveryForResume, StopLockOrder, getOrderSimple, saveOrder, clearLastVisitedOrderId } from '../../../../actions/orders'
import { invoiceOrder, invoiceHistory } from '../../../../actions/invoicing'

// import components
import ActionMenu from '../../ActionMenu'
import Portal from '../../Portal'
import Confirm from '../../Confirm'
import ResendText from './ResendText'
import store from '../../../../store'

// Modals
import PhotoDocModal from '../../../modals/PhotoDocModal'
import MoveModal from '../../../modals/MoveModal'
import LinkOrdersModal from '../../../modals/LinkOrdersModal'
import CreateEstimationModal from '../../../modals/CreateEstimationModal'
import ReferenceOrderModal from '../../../modals/ReferenceOrderModal'
import StopLockOrderModal from '../../../modals/StopLockOrderModal'
import QualityCheckModal from '../../../modals/QualityCheckModal'
import OtherPriceModal from '../../../modals/OtherPriceModal'
import MarkAsWreckedModal from '../../../modals/MarkAsWreckedModal'
import ReferenceOrderActionModal from '../../../modals/ReferenceOrderActionModal'

// Utils
import { hasAccess, hasSubscriptionPermission, hasAccessToAssign } from '../../../../utils/auth'
import { translation, enumtranslate } from '../../../../utils/helpers'
import { AssessmentSystemType } from '../../../../constants'

// Elements
// import Check from '../../../elements/check'

class OrderActions extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {
      confirm: {
        open: false
      },
      cancelReferral: {
        open: false
      },
      photodoc: {
        open: false
      },
      moveItem: {
        open: false,
        type: 0
      },
      linkorders: {
        open: false,
        id: 0
      },
      estimation: {
        open: false,
        id: 0
      },
      referenceorder: {
        open: false,
        id: 0
      },
      stoplockorder: {
        open: false,
        id: 0
      },
      quality: {
        open: false,
        data: {},
        index: 0,
        pos: 0
      },
      assignEmployees: {
        open: false
      },
      showAddonPopup: false,
      confirmResendInvoice: {
        open: false,
        splitAddon: false,
        hasAddon: false
      },
      item: {},
      otherPopup: {
        open: false,
        other: {
          Title: '',
          Price: '',
          Environment: '',
          Description: ''
        }
      },
      lastHistory: {
        FoundHistory: false
      },
      isLoadingLastHistory: false,
      confirmMarkAsWrecked: {
        open: false
      },
      newDelivery: undefined,
      isMoreThanHalfAnHour: false,
      isStopped: false
    }
    this.handleClick = this.handleClick.bind(this)
    this.renderActionMenu = this.renderActionMenu.bind(this)
    this.onConfirm = this.onConfirm.bind(this)
    this.onConfirmResend = this.onConfirmResend.bind(this)
    this.updateRow = this.updateRow.bind(this)
    this.renderConfirmResendInvoiceDialog = this.renderConfirmResendInvoiceDialog.bind(this)
    this.confirmAddon = this.confirmAddon.bind(this)
  }

  componentDidMount () {
    this._mounted = true
    let item = { ...this.props.item }
    item.StepIndex = this.props.step
    item.ItemIndex = this.props.index
    this.setState({
      confirmResendInvoice: {
        open: false,
        splitAddon: item.SeparateAddonInvoice,
        hasAddon: false
      },
      item: item,
      otherPopup: {
        open: false,
        other: {
          Title: item.OtherTitle,
          Price: item.Price,
          Environment: item.Environment,
          Description: item.Description
        }
      }
    })
  }

  componentWillReceiveProps (nextProps) {
    if (!isEqual(this.props.item, nextProps.item)) {
      let item = { ...nextProps.item }
      item.StepIndex = this.props.step
      item.ItemIndex = this.props.index
      this.setState({
        confirmResendInvoice: {
          open: false,
          splitAddon: item.SeparateAddonInvoice,
          hasAddon: false
        },
        item: item,
        otherPopup: {
          open: false,
          other: {
            Title: item.OtherTitle,
            Price: item.Price,
            Environment: item.Environment,
            Description: item.Description
          }
        }
      })
    }
  }

  componentWillUnmount () {
    this._mounted = false
  }

  handleClick (el) {
    switch (el.dataset.action) {
      case 'delete':
        this.setState({
          confirm: {
            open: !this.state.confirm.open
          }
        })
        break
      case 'cancelReferral':
        this.props.triggerPopup(!this.state.cancelReferral.open)
        this.setState({
          cancelReferral: {
            open: !this.state.cancelReferral.open
          }
        })
        break
      case 'photo':
        this.props.triggerPopup(!this.state.photodoc.open)
        this.setState({
          photodoc: {
            open: !this.state.photodoc.open
          }
        })
        break
      case 'estimation':
        this.props.triggerPopup(!this.state.estimation.open)
        this.setState({
          estimation: {
            open: !this.state.estimation.open,
            id: this.state.item.Id
          }
        })
        break
      case 'linkOrders':
        this.props.triggerPopup(!this.state.linkorders.open)
        this.setState({
          linkorders: {
            open: !this.state.linkorders.open,
            id: this.state.item.Id
          }
        })
        break
      case 'referenceOrder':
        this.props.triggerPopup(!this.state.referenceorder.open)
        this.setState({
          referenceorder: {
            open: !this.state.referenceorder.open,
            id: this.state.item.Id
          }
        })
        break
      case 'stopLockOrder':
        if (this.state.item.IsStopped) {
          this.props.GetNewDeliveryForResume(this.props.item.Id).then(res => {
            if (res.data !== null) {
              this.setState({
                newDelivery: res.data.NewDeliveryDateTime,
                isMoreThanHalfAnHour: res.data.IsMoreThanHalfAnHour,
                isStopped: res.data.IsStopped
              }, () => {
                // isStopped = false from backend if not manual stop
                this.props.triggerPopup(!this.state.stoplockorder.open)
                this.setState({
                  stoplockorder: {
                    open: !this.state.stoplockorder.open,
                    id: this.state.item.Id
                  }
                })
              })
            }
          })
        } else {
          this.props.triggerPopup(!this.state.stoplockorder.open)
          this.setState({
            stoplockorder: {
              open: !this.state.stoplockorder.open,
              id: this.state.item.Id
            }
          })
        }

        break
      case 'move':
        this.props.triggerPopup(!this.state.moveItem.open)
        let item = { ...this.state.item }
        // item.NewStepId = (parseInt(el.dataset.type) === 1) ? item.StepId - 1 : item.StepId + 1
        this.setState({
          moveItem: {
            open: !this.state.moveItem.open,
            type: parseInt(el.dataset.type)
          },
          item: item
        })
        break
      case 'finishOrder':
        // this.props.triggerPopup(!this.state.moveItem.open) // disabled - would trigger modal state but never revert.
        this.props.onOrderMove({ OrderIds: [this.props.item.Id], UserId: 0, StepFrom: this.props.item.StepId, StepTo: 8  /*  (item.StepId + 1) */, Comment: '', FilterSettings: {} })
        break
      case 'afterevaluation':
        this.props.router.push('/pricecalculation/' + this.props.item.Id + '/4')
        break
      case 'newpricecalculation':
        if (this.props.item.OrderType !== 4) {
          this.props.router.push('/pricecalculation/' + this.props.item.Id + '/1')
        } else {
          this.setState({
            otherPopup: {
              ...this.state.otherPopup,
              open: true
            }
          })
        }
        break
      case 'internalDeviation':
        this.props.router.push('/pricecalculation/' + this.props.item.Id + '/5')
        // To prevent possibly changing an earlier orderPrice in Extent
        window.location.reload()
        break
      case 'externalDeviation':
        this.props.router.push('/pricecalculation/' + this.props.item.Id + '/6')
        // To prevent possibly changing an earlier orderPrice in Extent
        window.location.reload()
        break
      case 'resendInvoice':
        this.setState({
          isLoadingLastHistory: true
        }, () => {
          this.props.invoiceHistory(this.props.item.Id).then((res) => {
            this.setState({
              lastHistory: res.data,
              isLoadingLastHistory: false
              // }, { () => console.log('[OrderActions][loadinglasthistory]', this.state)
            })
          })
        })
        this.setState({
          confirmResendInvoice: {
            ...this.state.confirmResendInvoice,
            open: !this.state.confirmResendInvoice.open
          }
        })
        break
      case 'evaluationHistory':
        this.props.router.push('/evaluationhistory/' + this.props.item.Id)
        break
      case 'assignEmployees':
        this.setState({
          assignEmployees: {
            open: true
          }
        }, () => {
          // this.props.checkForPopups()
          this.props.triggerClickAssign()
        })
        break
      case 'markAsWrecked':
        this.props.triggerPopup(!this.state.confirmMarkAsWrecked.open)
        this.setState({
          confirmMarkAsWrecked: {
            open: true
          }
        })
        break
    }
  }

  renderActionMenu () {
    let { item } = this.state
    // Render move back
    let shouldNotRender = !hasAccess([3, 5, 7], this.props.auth.user.UserType) || this.props.itemType === '1' || item.IsDraft || !hasSubscriptionPermission(this.props.auth, 0, 1)
    const renderMoveBack = () => {
      if (shouldNotRender) return null
      if (this.props.item.IsReferredOut) return null
      if (item.StepId !== 0 && item.StepId !== 1 && item.StepId !== 8 && (hasAccess([7], this.props.auth.user.UserType) || !hasSubscriptionPermission(this.props.auth, 30) || hasSubscriptionPermission(this.props.auth, 30, 20))) {
        return <a data-action='move' data-type='1'><img src='/images/icons/Backward.png' />{translation('13481')}</a>
      }
      return null
    }
    // Render move forward
    const renderMoveForward = () => {
      if (shouldNotRender) return null
      if (this.props.item.IsReferredOut) return null
      if (item.StepId < 7 || item.StepId > 8) {
        return <a data-action='move' data-type='2'><img src='/images/icons/Forward.png' />{translation('13479')}</a>
      }
      return null
    }
    // Render move forward
    const renderFinishOrder = () => {
      if (shouldNotRender) return null
      if (this.props.item.IsReferredOut) return null
      if (item.StepId === 7 && !hasSubscriptionPermission(this.props.auth, 20, 1)) {
        return <a data-action='finishOrder'><img src='/images/icons/Forward.png' />{translation('15269')}</a>
      }
      return null
    }
    // Render after evaluation
    const renderAfterEvaluation = () => {
      if (!hasAccess([3, 5, 6, 7], this.props.auth.user.UserType) || (!hasSubscriptionPermission(this.props.auth, 30, 26)) && !hasAccess([6], this.props.auth.user.UserType)) return null
      if (item.IsDraft) return null
      if (item.OrderDepartment === 1) return null
      if (this.props.auth.user.DepartmentType === 1) return null
      if (item.OrderType === 1) {
        return <a data-action='afterevaluation'><img src='/images/svgs/menuicons/after-charge.svg' />{translation('1037')}</a>
      }
      return null
    }
    // render new pricecalculation
    const renderNewPriceclaculations = () => {
      if (!hasAccess([3, 5, 6, 7], this.props.auth.user.UserType) || !hasSubscriptionPermission(this.props.auth, 20, 2)) return null
      if (item.OrderDepartment === 1 || item.IsDraft) return null
      if (this.props.auth.user.DepartmentType === 1) return null
      if (item.IsAssessmentOk) return null
      if (item.OrderType !== 1) {
        return <a data-action='newpricecalculation'><img src='/images/svgs/menuicons/New_price_calculation.svg' />{translation('13565')}</a>
      }
      return null
    }
    // Render quality doc
    const renderQualityDoc = () => {
      if (!hasAccess([3, 5, 7], this.props.auth.user.UserType) || !hasSubscriptionPermission(this.props.auth, 10, 21)) return null
      // if (item.OrderDepartment === 1) return null
      // if (this.props.auth.user.DepartmentType === 1) return null
      return <a data-action='photo'><img src='/images/icons/Camera.png' />{translation('2065')}</a>
    }
    // Render delete
    const renderDelete = () => {
      if (item.IsReferredIn || item.IsReferredOut) {
        // Can only cancel referral on paint
        if (this.props.auth.user.DepartmentType === 0 && item.StepId === 1 && item.IsReferredIn && hasSubscriptionPermission(this.props.auth, 0, 32)) {
          return <a data-action='cancelReferral'><img src='/images/icons/Delete.png' />{translation('15225')}</a>
        }
        return null
      }
      if (this.props.auth.departmentType === 0 && item.HasExternalCompany) return null
      if (item.StepId === 1 && this.props.itemType !== '1') {
        // if (hasAccess([4], this.props.auth.user.UserType) || !item.IsDraft || !hasSubscriptionPermission(this.props.auth, 0, 2)) {
        if ((hasAccess([4], this.props.auth.user.UserType) && !item.IsDraft) || !hasSubscriptionPermission(this.props.auth, 0, 32)) {
          return null
        }
        return <a data-action='delete'><img src='/images/icons/Delete.png' />{translation('786')}</a>
      }
      return null
    }
    // Render empty message
    const renderEmptyMessage = () => {
      // if (hasAccess([4], this.props.auth.user.UserType) && item.StepId !== 1 && !item.IsDraft) {
      if (hasAccess([4], this.props.auth.user.UserType) && !item.IsDraft && item.IsEvaluation && !item.IsEvaluationRejected) {   // No valid options for user
        return <span>{translation('2023')}</span>
      }
      return null
    }
    // Deviation links
    const renderInternalDeviationLink = () => {
      if (!hasAccess([3, 5, 7], this.props.auth.user.UserType) || !hasSubscriptionPermission(this.props.auth, 30, 20) || this.props.item.OrderType === 4) return null
      if (item.IsDraft) return null
      if (item.OrderDepartment === 1) return null
      if (this.props.auth.user.DepartmentType === 1) return null
      return (
        <a data-action='internalDeviation'><img src='/images/icons/External-Deviation.png' />{translation('310')}</a> // It is the correct img
      )
    }
    const renderExternalDeviationLink = () => {
      if (!hasAccess([3, 5, 7], this.props.auth.user.UserType) || !hasSubscriptionPermission(this.props.auth, 30, 20) || this.props.item.OrderType === 4) return null
      if (item.IsDraft) return null
      if (item.OrderDepartment === 1) return null
      if (this.props.auth.user.DepartmentType === 1) return null
      return (
        <a data-action='externalDeviation'><img src='/images/icons/Internal-Deviation.png' />{translation('311')}</a> // It is the correct img
      )
    }
    // Link orders
    const linkOrders = () => {
      if (item.IsDraft || this.props.auth.departmentType === 1) return null
      if (!hasAccess([3, 5, 7], this.props.auth.user.UserType) || this.props.itemType === '1' || this.props.step === 9 || !hasSubscriptionPermission(this.props.auth, 30, 13)) return renderNewPriceclaculations
      // if (item.OrderDepartment === 1) return null
      // if (this.props.auth.user.DepartmentType === 1) return null
      return (
        <a data-action='linkOrders'><img src='/images/icons/Link-Black.png' />{translation('1848')}</a>
      )
    }
    const createEstimation = () => {
      if (!hasSubscriptionPermission(this.props.auth, 30)) return null
      if (item.IsEvaluation && !item.IsEvaluationRejected || (item.OrderType === 4 || item.OrderType === 5)) return null
      if (item.OrderDepartment === 1 && !item.IsPaintOrder) return null
      if (item.IsReferredIn) return null
      if (item.StepId === 8) return null
      return (
        <a data-action='estimation'><img src='/images/svgs/menuicons/additional-support_VS.svg' />{translation('13363')}</a>
      )
    }
    // Reference order
    const referenceOrder = () => {
      // console.log('reference order', 'itemType', this.props.itemType, 'item', item, 'auth', this.props.auth, 'IsReferrable', item.IsReferrable)
      if (!hasAccess([3, 5, 7], this.props.auth.user.UserType) || this.props.itemType === '1' || !hasSubscriptionPermission(this.props.auth, 30, 5)) return null
      if (!item.IsReferrable) return null
      return (
        <a data-action='referenceOrder'><img src='/images/icons/Referred16.png' />{translation('2106')}</a>
      )
    }
    // Stop Lock Order
    const stopLockOrder = () => {
      if (!hasAccess([3, 5, 7], this.props.auth.user.UserType) || this.props.itemType === '1') return null
      if (!hasSubscriptionPermission(this.props.auth, 10, 13)) return null
      if (this.props.item.IsReferredOut) return null
      if (item.StepId === 8 || item.IsDraft) return null
      // if (this.props.auth.departmentType === 1) { return null }
      if (this.state.item.IsStopped) {
        return (<a data-action='stopLockOrder'><img src='/images/icons/stop-hand-32x32.png' />{translation('2220')}</a>)
      }
      return (<a data-action='stopLockOrder'><img src='/images/icons/stop-hand-32x32.png' />{translation('2218')}</a>)
    }
    // Resend for invoicing
    const resendInvoice = () => {
      if (this.props.type === 'workscreen') return null
      if (!hasAccess([3, 5, 6, 7], this.props.auth.user.UserType) || this.props.itemType === '1') return null
      if (this.props.item.IsDraft || !hasAccess([6], this.props.auth.user.UserType) && !(this.props.item.IsInvoiced || this.props.item.IsMarkInvoiced)) return null
      if (hasAccess([6], this.props.auth.user.UserType) && !(this.props.item.IsInvoicedByWP || this.props.item.IsMarkInvoicedByWP)) return null
      if (!hasSubscriptionPermission(this.props.auth, 10, 6)) return null
      return (<a data-action='resendInvoice'><img src='/images/svgs/invoice/resend-for-invoice.svg' />{translation('13508')}</a>)
    }
    // Evaluation history
    const renderEvaluationHistoryLink = () => {
      if (!hasAccess([3, 5, 6, 7], this.props.auth.user.UserType) || !hasSubscriptionPermission(this.props.auth, 20, 31) || this.props.auth.departmentType !== 0 || this.props.item.IsDraft || this.props.auth.permissions.ChainAssessmentSystem === AssessmentSystemType.DBS) return null
      return (<a data-action='evaluationHistory'><img src='/images/icons/Actions_Assessment_history.svg' />{translation('14920')}</a>)
    }
    // Assign employees
    const assignEmployees = () => {
      if (!hasAccess([3, 5, 7], this.props.auth.user.UserType) || this.props.item.IsDraft) return null
      if (!hasAccessToAssign(this.props.auth)) return null
      if (!hasSubscriptionPermission(this.props.auth, 10)) return null
      if (!hasSubscriptionPermission(this.props.auth, 20) && this.props.auth.departmentType === 1 && this.props.type === 'workscreen') return null
      if (this.state.item.IsArchived) return null
      if (this.props.type === 'workscreen') return null
      return (<a data-action='assignEmployees'><img src='/images/icons/menu/Assign.png' />{translation('1856')}</a>)
    }

    const renderMarkAsWrecked = () => {
      if (this.props.auth.departmentType === 0 || this.props.item.IsDraft || this.props.item.StepId === 8 || !hasAccess([3, 7], this.props.auth.user.UserType)) return null
      if (!hasSubscriptionPermission(this.props.auth, 30)) return null
      return (<a data-action='markAsWrecked'><img src='/images/svgs/actions/total-wreck.svg' />{translation('15239')}</a>)
    }

    // Return
    return (
      <div className='poppedup'>
        {renderEmptyMessage()}
        {renderDelete()}
        {renderQualityDoc()}
        {renderInternalDeviationLink()}
        {renderExternalDeviationLink()}
        {renderAfterEvaluation()}
        {renderNewPriceclaculations()}
        {renderMoveBack()}
        {renderMoveForward()}
        {renderFinishOrder()}
        {linkOrders()}
        {createEstimation()}
        {referenceOrder()}
        {stopLockOrder()}
        {resendInvoice()}
        {renderEvaluationHistoryLink()}
        {assignEmployees()}
        {renderMarkAsWrecked()}
      </div>
    )
  }

  onPortalClose (type) {
    if (this._mounted) {
      this.setState({
        [type]: {
          ...this.state[type],
          open: false
        }
      })
    }
    this.props.triggerPopup(false)
  }

  stopLockResumeWithoutPopUp () {
    let data = {
      ApplyToInvoice: this.state.item.OrderStop.StoppedMessageApplyToInvoice,
      ShowCustomer: this.state.item.OrderStop.StoppedMessageShowCustomer,
      Message: this.state.item.OrderStop.StoppedMessage,
      OrderId: this.props.item.Id,
      TimeAction: 2 // keep old time
    }
    this.props.StopLockOrder(data).then((res) => {
      // window.toastr.success(translation('13403'), translation('13424'))
      this.onPortalClose('stoplockorder')
    }, () => {
      window.toastr.error(translation('13404'), translation('216'))
    })
  }
  onConfirm () {
    if (this.props.type === 'workscreen') {
      this.props.deleteOrderSimple(this.props.item.Id).then(() => {
        // Close
        if (this._mounted) {
          this.onPortalClose('confirm')
        }
        // Emit event
        EventEmitter.emit('workcard_delete', {
          id: this.props.item.Id,
          step: this.props.step,
          index: this.props.index
        })
        // Toastr
        // window.toastr.success(translation('2021'), translation('13424'))
      }, () => {
        // Toastr
        window.toastr.error(translation('2022'), translation('216'))
        // Close
        this.onPortalClose('confirm')
      })
    } else {
      // Delete
      this.props.deleteOrder(this.props.item.Id, this.props.step, this.props.index).then(() => {
        // Toastr
        // window.toastr.success(translation('2021'), translation('13424'))
        // Close
        if (this._mounted) {
          this.onPortalClose('confirm')
        }
        // Update list
        this.props.deleteOrderIndex(this.props.step, this.props.index)
      }, () => {
        // Toastr
        window.toastr.error(translation('2022'), translation('216'))
        // Close
        if (this._mounted) {
          this.onPortalClose('confirm')
        }
      })
    }
  }

  confirmAddon (val) {
    this.setState({
      showAddonPopup: false,
      confirmResendInvoice: {
        ...this.state.confirmResendInvoice,
        splitAddon: val
      }
    }, () => { this.onConfirmResend(true) })
  }

  renderConfirmResendInvoiceDialog () {
    // const showClickError = (e) => {
    //   let disabled = !this.props.item.CanChangeAddonInvoice
    //   if (!disabled) return null
    //   let error = translation('14806')
    //   error = error.replace('[WPName]', this.props.item.WPName)
    //   window.toastr.error(error, translation('216'))
    // }
    // let checked = this.state.confirmResendInvoice.splitAddon
    // let disabled = !this.props.item.CanChangeAddonInvoice
    let t = translation
    return (
      <ResendText isLoadingLastHistory={this.state.isLoadingLastHistory} lastHistory={this.state.lastHistory} store={store} t={t} />
    )
  }

  onConfirmResend (addonChecked = false) {
    if (this.state.confirmResendInvoice.open === true || this.state.showAddonPopup === true) {
      this.setState({
        showAddonPopup: false,
        confirmResendInvoice: {
          ...this.state.confirmResendInvoice,
          open: false
        }
      })
    }
    if (this.props.item.HasAddonPrice && this.props.item.CanChangeAddonInvoice && !addonChecked) {
      this.setState({
        showAddonPopup: true
      })
      return null
    }
    let splitAddon = this.props.item.HasAddonPrice && this.state.confirmResendInvoice.splitAddon
    let data = {
      OrderId: this.props.item.Id,
      SplitAddon: splitAddon
    }
    this.props.invoiceOrder(data).then((res) => {
      // Toastr
      // window.toastr.success(translation('13506'), translation('13424'))
      // Close
    }, (err) => {
      if (err.response) {
        if (err.response.data !== undefined && err.response.data.Error !== undefined) {
          let error = err.response.data.Error
          let errorText = translation('960')
          // OrderNotFound = 1,
          // CompanyNotFound = 2,
          // NotValidEconomicCredentials = 3,
          // NotValidHeliosNumber = 4,
          // NotValidC5UserPass = 5,
          // OrderIsAlreadySent = 6,
          switch (error) {
            case 0:
              errorText = translation('13700')
              break
            case 1:
              errorText = translation('13701')
              break
            case 2:
              errorText = translation('13702')
              break
            case 3:
              errorText = translation('13703')
              break
            case 4:
              errorText = translation('13704')
              break
            case 5:
              errorText = translation('13705')
              break
            case 6:
              errorText = translation('13706')
              break
            case 7:
              errorText = translation('13707')
              break
            case 8:
              errorText = translation('2710')
              break
            case 9:
              errorText = translation('14851')
              break
            case 10:
              errorText = translation('16616')
              break
            case 11:
              errorText = translation('16617')
              break
            case 12:
              errorText = translation('16650')
              break
            case 13:
              errorText = translation('16618')
              break
            case 14:
              errorText = translation('16636')
              break
            case 15:
              errorText = translation('16651')
              break
            case 16:
              errorText = translation('16619')
              break
            case 17:
              errorText = translation('17947')
              break
            case 18:
              errorText = translation('18145')
              break
            case 19:
              errorText = translation('18144')
              break
            default: break
          }
          window.toastr.error(errorText, translation('216'))
        } else {
          window.toastr.error(translation('960'), translation('216'))
        }
      } else {
        window.toastr.error(translation('960'), translation('216'))
      }
    })
    if (this._mounted) {
      this.onPortalClose('confirmResendInvoice')
    }
  }

  updateRow (data, pos, index) {
    EventEmitter.emit('update_row-' + this.props.type, {
      data: data,
      pos: pos,
      index: index
    })
  }

  onMoveFailed (data, pos, index) {
    this.setState({
      quality: {
        open: true,
        data: data,
        pos: pos,
        index: index
      }
    })
  }

  moveOrderSuccess (data) {
    this.onPortalClose('quality')
    this.updateRow(data.CurrentStepOrders, this.state.quality.pos, this.state.quality.index)
  }

  render () {
    let disableResend = this.state.isLoadingLastHistory === true
    let isDuplicate = this.props.item.OrderKey !== undefined && this.props.item.OrderKey !== null && this.props.item.OrderKey.endsWith('_LoosePart')
    let isCustomer = (hasAccess([4], this.props.auth.user.UserType))
    let onOpenFunction = this.props.router.location.pathname === '/orders' ? this.props.clearLastVisitedOrderId : undefined

    if (isCustomer && !this.props.item.IsDraft && !hasSubscriptionPermission(this.props.auth, 20)) {
      return (
        <div className='order__action' />
      )
    }
    if (isDuplicate || (this.props.item.NeedReferredApprove && this.props.item.ReferredApproved !== true)) {
      return (
        <div className='order__action'>
          <div className='action_opener' />
        </div>
      )
    }
    return (
      <div className='order__action'>
        <ActionMenu renderActionMenu={this.renderActionMenu} handleClick={this.handleClick} open={this.props.open} type={this.props.type} isStarted={this.props.isStarted} onOpen={onOpenFunction} />
        {this.state.cancelReferral.open && (
          <Portal portalId='cancelReferral' onPortalClose={this.onPortalClose.bind(this, 'cancelReferral')} dontSendT>
            <ReferenceOrderActionModal
              show={this.state.cancelReferral.open}
              item={this.props.item}
              id={this.props.item.Id}
              onClose={this.onPortalClose.bind(this, 'cancelReferral')}
              department={this.props.auth.departmentType} />
          </Portal>
        )}
        {this.state.quality.open && (
          <QualityCheckModal
            show={this.state.quality.open}
            data={this.state.quality.data}
            onSuccess={this.moveOrderSuccess.bind(this)}
            onClose={this.onPortalClose.bind(this, 'quality')}
            move
            router={this.props.router} />
        )}
        {this.state.photodoc.open && (
          <Portal portalId='photoDoc' onPortalClose={this.onPortalClose.bind(this, 'photodoc')} dontSendT>
            <PhotoDocModal
              show={this.state.photodoc}
              item={this.state.item}
              onClose={this.onPortalClose.bind(this, 'photodoc')}
              t={translation}
              enumfunc={enumtranslate} />
          </Portal>
        )}
        {this.state.moveItem.open && (
          <Portal portalId='moveItem' onPortalClose={this.onPortalClose.bind(this, 'moveItem')} dontSendT>
            <MoveModal router={this.props.router}
              show={this.state.moveItem.open}
              item={this.state.item}
              type={this.state.moveItem.type}
              onClose={this.onPortalClose.bind(this, 'moveItem')}
              onMoveOrders={this.props.onOrderMove.bind(this)} />
          </Portal>
        )}
        {this.state.estimation.open && (
          <Portal portalId='estimation' onPortalClose={this.onPortalClose.bind(this, 'estimation')} dontSendT>
            <CreateEstimationModal router={this.props.router}
              show={this.state.estimation.open}
              id={this.state.estimation.id}
              orderId={this.state.item.Id}
              onClose={this.onPortalClose.bind(this, 'estimation')} />
          </Portal>
        )}
        {this.state.linkorders.open && (
          <Portal portalId='linkOrders' onPortalClose={this.onPortalClose.bind(this, 'linkorders')} dontSendT>
            <LinkOrdersModal
              show={this.state.linkorders.open}
              id={this.state.linkorders.id}
              onClose={this.onPortalClose.bind(this, 'linkorders')} />
          </Portal>
        )}
        {this.state.referenceorder.open && (
          <Portal portalId='referenceOrder' onPortalClose={this.onPortalClose.bind(this, 'referenceorder')} dontSendT>
            <ReferenceOrderModal
              show={this.state.referenceorder.open}
              item={this.state.item}
              id={this.state.referenceorder.id}
              onClose={this.onPortalClose.bind(this, 'referenceorder')} />
          </Portal>
        )}
        {this.state.stoplockorder.open && (
          <Portal portalId='stopLockOrder' onPortalClose={this.onPortalClose.bind(this, 'stoplockorder')} dontSendT>
            <StopLockOrderModal
              show={this.state.stoplockorder.open}
              item={this.state.item}
              id={this.state.stoplockorder.id}
              newDelivery={this.state.newDelivery}
              onClose={this.onPortalClose.bind(this, 'stoplockorder')} />
          </Portal>
        )}
        {(this.state.confirm.open && this.props.item.StepId === 1) && (
          <Portal className='deleteModal' onPortalClose={this.onPortalClose.bind(this, 'confirm')}>
            <Confirm confirm={this.onConfirm} notConfirm={this.onPortalClose.bind(this, 'confirm')} />
          </Portal>
        )}
        {(this.state.confirmResendInvoice.open) && (
          <Portal className='resendModal' onPortalClose={this.onPortalClose.bind(this, 'confirmResendInvoice')}>
            <Confirm renderText={this.renderConfirmResendInvoiceDialog} confirm={() => this.onConfirmResend(false)} notConfirm={this.onPortalClose.bind(this, 'confirmResendInvoice')} disabled={disableResend} />
          </Portal>
        )}
        {(this.state.confirmMarkAsWrecked.open) && (
          <Portal portalId='markAsWrecked' onPortalClose={this.onPortalClose.bind(this, 'confirmMarkAsWrecked')} dontSendT>
            <MarkAsWreckedModal
              show={this.state.confirmMarkAsWrecked.open}
              order={this.state.item}
              onClose={this.onPortalClose.bind(this, 'confirmMarkAsWrecked')}
              onMoveSuccess={this.props.onOrderMoveSuccess} />
          </Portal>
        )}
        {(this.state.item.OrderType === 4) && this.state.otherPopup.open && (
          <Portal portalId='otherPriceModal' onPortalClose={this.onPortalClose.bind(this, 'otherPopup')} dontSendT>
            <OtherPriceModal
              type={1}
              show={this.state.otherPopup.open}
              onClose={this.onPortalClose.bind(this, 'otherPopup')}
              other={this.state.otherPopup.other}
              order={this.state.item}
              onSuccess={this.onPortalClose.bind(this, 'otherPopup')}
              saveOrder={this.props.saveOrder} />
          </Portal>
        )}
        {this.state.showAddonPopup && (
          <Confirm
            t={translation}
            renderText={() => translation('16485')}
            confirm={() => this.confirmAddon(true)}
            notConfirm={() => this.confirmAddon(false)} />
        )}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  triggerPopup,
  deleteOrder,
  deleteOrderSimple,
  moveOrder,
  invoiceOrder,
  invoiceHistory,
  GetNewDeliveryForResume,
  StopLockOrder,
  getOrderSimple,
  saveOrder,
  clearLastVisitedOrderId
}, null, { withRef: true })(OrderActions)



// WEBPACK FOOTER //
// ./src/app/shared/components/ActionMenu/OrderActions/index.js